import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header.js';
import Hero from './components/sections/Hero.js';
import About from './components/sections/About.js';
import Partners from './components/sections/Partners.js';
import Projects from './components/sections/Projects.js';
import PricingPage from './components/pages/PricingPage.js';
import FAQPage from './components/pages/FAQPage.js';
import ContactPage from './components/pages/ContactPage.js';
import Footer from './components/layout/Footer.js';
import WhatsAppButton from './components/layout/WhatsAppButton.js';
import FigBotButton from './components/layout/FigBotButton.js';
import ScrollToTop from './components/layout/ScrollToTop.js';
import PrivacyPolicy from './components/pages/PrivacyPolicy.js';
import CookiePolicy from './components/pages/CookiePolicy.js';
import TermsConditions from './components/pages/TermsConditions.js';
import AccessibilityStatement from './components/pages/AccessibilityStatement.js';
import RefundCancellationPolicy from './components/pages/RefundCancellationPolicy.js';
import DataProcessingAgreement from './components/pages/DataProcessingAgreement.js';
import CsrPolicy from './components/pages/CsrPolicy.js';
import SustainabilityPolicy from './components/pages/SustainabilityPolicy.js';
import CustomWorkTerms from './components/pages/CustomWorkTerms.js';
import Articles from './components/pages/Articles.js';
import ArticleDetail from './components/pages/ArticleDetail.js';
import AIAutomation from './components/pages/AIAutomation.js';
import WebsitePackagesTerms from './components/pages/WebsitePackagesTerms.js';
import CampaignResearchTool from './components/pages/CampaignResearchTool.js';
import './styles/global.css';
import './styles/mobile.css';
import './styles/visual-enhancements.css';
import './App.css';
import Chatbot from './components/Chatbot.js';

// Main homepage component
const HomePage = () => (
  <main>
    <Hero />
    <About />
    <Partners />
    <Projects />
  </main>
);

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/refund-policy" element={<RefundCancellationPolicy />} />
          <Route path="/data-processing" element={<DataProcessingAgreement />} />
          <Route path="/website-packages-terms" element={<WebsitePackagesTerms />} />
          <Route path="/campaign-research-tool" element={<CampaignResearchTool />} />
          <Route path="/csr-policy" element={<CsrPolicy />} />
          <Route path="/sustainability-policy" element={<SustainabilityPolicy />} />
          <Route path="/custom-work-terms" element={<CustomWorkTerms />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/ai-automation" element={<AIAutomation />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        {isChatbotOpen && <Chatbot onClose={toggleChatbot} />}
        <Footer />
        <WhatsAppButton />
        <FigBotButton onClick={toggleChatbot} />
      </div>
    </Router>
  );
}

export default App;
